<div class="modal-header">
    <h3 class="modal-title">Delete Bulletin</h3>
</div>
<div class="modal-body">
    <p>
        Are you sure you want to delete the bulletin "{{bulletinHeader}}" ?
    </p>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-danger" (click)="deleteClicked()">Delete</button>
    <button type="button" class="btn btn-outline-dark" (click)="cancelClicked()">Cancel</button>
</div>